export const getPercentageData = (nmtr, dnmtr, digit=0, replace='-') => {
  let dgt = Math.pow(10, digit)
  let pct = nmtr * dgt / dnmtr
  return isNaN(pct)? replace:`${Math.round(pct*100)/dgt}%`
}
export const getDecimalData = (nmtr, dnmtr, digit=3, replace='-') => {
  if (dnmtr === 0) return replace
  let dgt = Math.pow(10, digit)
  let fac = nmtr * dgt / dnmtr

  //handle decimal place count
  let output = Math.round(fac)/dgt
  let numstr = output.toString()
  if (numstr.indexOf('.') === -1) {
    numstr += '.'
    for (let i=0; i<digit; i++) numstr += '0'
  } else {
    let dotindex = numstr.indexOf('.')
    let placeLen = numstr.length - dotindex -1
    while (placeLen < digit) {
      placeLen++
      numstr += '0'
    }
  }
  return isNaN(fac)? replace:numstr
}

export const checkImageExistense = (img_url) => {
  let http = new XMLHttpRequest()
  http.open('HEAD', img_url, false)
  try {
    http.send()
    return http.status !== 404
  } catch (e) {
    return true
  }
}
